/**
 * Tiny client-side A/B assignment helper. First visit → assigned to "control"
 * or "personalized" (50/50). Persists in localStorage. Also generates a stable
 * session_id so the backend can dedupe impressions and count unique clickers.
 *
 * No tracking pixels, no cookies, no third-party analytics.
 */
const VARIANT_KEY = "vmeetio:ab:trending_v1";
const SESSION_KEY = "vmeetio:session_id";

function uuid() {
  try {
    if (typeof crypto !== "undefined" && crypto.randomUUID) return crypto.randomUUID();
  } catch (_e) { /* ignore */ }
  return "s-" + Math.random().toString(36).slice(2) + Date.now().toString(36);
}

/** Returns the visitor's assigned trending-strip variant. Persists across visits. */
export function getTrendingVariant() {
  try {
    let v = localStorage.getItem(VARIANT_KEY);
    if (v !== "control" && v !== "personalized") {
      v = Math.random() < 0.5 ? "control" : "personalized";
      localStorage.setItem(VARIANT_KEY, v);
    }
    return v;
  } catch (_e) {
    return "personalized"; // private-mode fallback — keep the best UX
  }
}

/** Returns (and lazily creates) a stable session identifier in localStorage. */
export function getSessionId() {
  try {
    let s = localStorage.getItem(SESSION_KEY);
    if (!s) {
      s = uuid();
      localStorage.setItem(SESSION_KEY, s);
    }
    return s;
  } catch (_e) {
    return "anon-" + Date.now().toString(36);
  }
}
